module.exports = __webpack_public_path__ + "static/media/bg-image-v3.504c59d4.jpg";